import { Button, Modal } from 'react-bootstrap';
import React from "react";
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';

import 'react-widgets/dist/css/react-widgets.css';
import 'bootstrap/dist/css/bootstrap.css';
import { UnstyledTextAreaField } from '../common/Inputs';
import { sendSms } from '../../actions/customers';
import * as fetchingState from '../../constants/fetchingState';

const formName = 'SmsSendModal';

let SmsSendModal = class extends React.Component {
    constructor(props) {
        super(props);
        this._send = this._send.bind(this);
    }

    _send() {
        const phone = this.props.Phone;
        const text = this.props.messageText;
        this.props.sendSms(phone, text);
    }
    
    render() {
        const { Phone, onClose, messageText, fetching, sendError } = this.props;
        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{`Отправка смс уведомления (${Phone})`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {fetching === fetchingState.INITIAL && <Field name="messageText" component={UnstyledTextAreaField} />}
                    {fetching === fetchingState.FETCHED && <span>УСПЕХ</span>}
                    {fetching === fetchingState.FAILED && <span>{sendError}</span>}
                    {fetching === fetchingState.FETCHING && <span>ЗАГРУЗКА...</span>}
                </Modal.Body>

                <Modal.Footer>
                    {fetching === fetchingState.INITIAL && <Button bsStyle="success" type="button" onClick={this._send} disabled={!messageText}>Подтвердить</Button>}
                    <Button type="button" onClick={onClose}>Закрыть</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

SmsSendModal = reduxForm({
    form: formName
})(SmsSendModal);

function mapToProps(state, props) {
    const formValues = (getFormValues(formName)(state));
    const customerState = state.application.get('customer');
    return {
        messageText: formValues == null ? undefined : formValues.messageText,
        fetching: customerState != null ? customerState.smsSendFetching : undefined,
        sendError: customerState != null ? customerState.smsSendindErrors : undefined
    }
}

SmsSendModal = connect(mapToProps, {
    sendSms
})(SmsSendModal);

export default SmsSendModal;


// WEBPACK FOOTER //
// ./src/components/common/SmsSendModal.jsx